var _path;

var _excluded = ["title", "titleId"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.785 9.289 C 7.424 9.385,7.192 9.804,7.284 10.190 C 7.327 10.369,7.451 10.501,9.475 12.525 C 11.499 14.549,11.631 14.673,11.810 14.716 C 11.952 14.750,12.048 14.750,12.190 14.716 C 12.369 14.673,12.501 14.549,14.525 12.525 C 16.549 10.501,16.673 10.369,16.716 10.190 C 16.849 9.632,16.367 9.150,15.810 9.285 C 15.632 9.328,15.507 9.443,13.810 11.134 L 12.000 12.938 10.190 11.134 C 8.501 9.451,8.367 9.328,8.192 9.285 C 7.980 9.234,7.994 9.234,7.785 9.289 ",
    stroke: "none",
    fillRule: "evenodd",
    fill: "black"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.8d73b8a8.svg";
export { ForwardRef as ReactComponent };